
































































































import Vue from 'vue'
import { headers } from '@/components/Entities/constants'
import AddTagsDialog from '@/components/Entities/AddTagsDialog.vue'
import DataTableToolbar from '@/components/Global/DataTableToolbar.vue'
import EditEntityDrawer from '@/components/Entities/EditEntityDrawer.vue'
import ReadOnlyEntityDrawer from '@/components/Entities/ReadOnlyEntityDrawer.vue'
import { mutations, portalState } from '@/state'
import {
  apiDropdownsBusinesses,
  apiDropdownsEntityBrands,
  apiDropdownsEntityColors,
  apiDropdownsEntityEngineBrands,
  apiDropdownsEntityMaintenancePlans,
  apiDropdownsEntityTags,
  apiDropdownsEntityTypes,
  apiSendEntitiesCSVtoEmailUser,
  apiGetEntitiesPaginated,
  apiGetEntityDetails
} from '@/api'

export default Vue.extend({
  name: 'Entities',
  components: { AddTagsDialog, DataTableToolbar, EditEntityDrawer, ReadOnlyEntityDrawer },
  computed: {
    tableHeaders () {
      const tableHeaders = headers(this.t)
      if (!this.hasCustomers) {
        const userNameIndex = tableHeaders.findIndex((e: {value: string}) => e.value === 'user_name')
        tableHeaders.splice(userNameIndex, 1)
        const subscriptionIndex = tableHeaders.findIndex((e: {value: string}) => e.value === 'subscription')
        tableHeaders.splice(subscriptionIndex, 1)
      }
      return tableHeaders
    },
    hasCustomers () {
      return portalState.user.businesses.some((b: { has_customers: boolean }) => b.has_customers)
    },
    isOEM () {
      return portalState.user.businesses.some((b: { is_oem: string | null }) => b.is_oem)
    }
  },
  data () {
    return {
      addTagsModalOpened: false,
      editEntityDrawerOpened: false,
      readOnlyEntityDrawerOpened: false,
      reportMissingDrawerOpened: false,
      loading: true,
      loadingCSV: false,
      entities: [],
      selected: [],
      tags: [],
      entity: null,
      options: {},
      search: '',
      controller: null,
      totalServerItems: 0,
      queryParams: { direction: 'desc' },
      dropdowns: {
        types: [],
        maintenancePlans: [],
        businesses: [],
        plans: [],
        colors: [],
        brands: [],
        models: [],
        engineBrands: [],
        engineModels: [],
        tags: []
      }
    }
  },
  methods: {
    initialize () {
      if (this.controller) this.controller.abort()
      this.controller = new AbortController()

      this.editEntityDrawerOpened = false
      this.loading = true
      this.entities = []
      this.selected = []
      const { sortDesc, page, itemsPerPage } = this.options
      this.queryParams.direction = sortDesc[0] ? 'asc' : 'desc'
      const searchParam = this.search !== '' && typeof this.search === 'string' ? `&search=${this.search.toLowerCase()}` : ''
      const paginationConfig = {
        page, limit: itemsPerPage, direction: this.queryParams.direction, search: searchParam, signal: this.controller.signal
      }

      apiGetEntitiesPaginated(paginationConfig)
        .then((response: any) => {
          this.entities = response.data.data.map((e: any) =>
            ({
              ...e,
              tags: e?.tags?.map((t: { name: string }) => t.name).join(', ') || [],
              type: this.t({ s: `types.${e.type.name}`, component: 'general' })
            }))
          if (response?.data?.pagination?.total_pages < page) this.options.page = 1
          const { total } = response.data.pagination
          this.totalServerItems = total
          this.loading = false
        }).catch(e => {
          mutations.setSnackbar('error', e.response.data.message)
        }).finally(() => this.gsapFadeIn())
    },
    updateSearch (val: string) { this.search = val },
    async confirmCSVRequest () {
      const { isConfirmed } = await this.$swal({
        title: this.t({s: 'csvModal.title', component: 'EntityManagement' }),
        text: this.t({s: 'csvModal.text', component: 'EntityManagement' }),
        icon: 'info',
        showCloseButton: false,
        showCancelButton: true,
        cancelButtonText: this.t({s: 'stepper.cancel', component: 'EntityManagement' }),
        confirmButtonText: this.t({s: 'stepper.continue', component: 'EntityManagement' }),
        confirmButtonColor: '#1cad73',
        customClass: {
          title: this.$vuetify.theme.dark ? 'swal2-dark' : '',
          container: this.$vuetify.theme.dark ? 'swal2-dark' : '',
          content: this.$vuetify.theme.dark ? 'swal2-dark' : ''
        }
      })
      if (!isConfirmed) return
      apiSendEntitiesCSVtoEmailUser({ search: this.search }).then(() => {
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar' }))
      }).catch(e => {
        mutations.setSnackbar('error', e.response.data.message)
      })
    },
    closeDrawers () {
      this.editEntityDrawerOpened = false
      this.readOnlyEntityDrawerOpened = false
    },
    openAppropriateDrawer (read_only: boolean) {
      if (read_only) {
        this.readOnlyEntityDrawerOpened = true
      } else {
        this.editEntityDrawerOpened = true
      }
    },
    rowClickHandler (e: { id: string, read_only: boolean }) {
      if (this.editEntityDrawerOpened || this.readOnlyEntityDrawerOpened) {
        this.closeDrawers()
        return
      }
      apiGetEntityDetails(e.id).then(res => {
        this.entity = res.data.data
        const openReadOnly = this.entity.entity_properties.type === 'unregistered' || e.read_only
        this.openAppropriateDrawer(openReadOnly)
      }).catch(e => {
        mutations.setSnackbar('error', e.response.data.message)
      })
    },
    getDropdowns () {
      apiDropdownsEntityTypes().then(res => {
        const translatedTypes = res.data.data.map(((type: { id: string, name: string }) => {
          return  { id: type.id, name: this.t({ s: `types.${type.name}`, component: 'general' }) }
        }))

        this.dropdowns.types = translatedTypes
      })
      apiDropdownsEntityColors().then(res => {
        this.dropdowns.colors = res.data.data
      })
      apiDropdownsEntityBrands().then(res => {
        this.dropdowns.brands = res.data.data
      })
      apiDropdownsEntityEngineBrands().then(res => {
        this.dropdowns.engineBrands = res.data.data
      })
      apiDropdownsBusinesses().then(res => {
        this.dropdowns.businesses = res.data.data
      })
      apiDropdownsEntityMaintenancePlans().then(res => {
        this.dropdowns.maintenancePlans = res.data.data
      })
      apiDropdownsEntityTags().then(res => {
        this.dropdowns.tags = res.data.data
      })
    }
  },
  mounted () {
    this.getDropdowns()
  },
  watch: {
    options: {
      handler () {
        this.initialize()
      },
      deep: true
    },
    search () {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.initialize()
      }, 500)
    }
  }
})
